import { cloneElement, forwardRef, HTMLProps, isValidElement, useMemo } from 'react'
import { mergeRefs } from 'react-merge-refs'

import { TooltipState } from './useTooltipState'

export const TooltipAnchor = forwardRef<
  HTMLElement,
  HTMLProps<HTMLElement> & {
    state: TooltipState
  }
>(function TooltipAnchor({ children, state, ...props }, propRef) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const childrenRef = (children as any).ref
  const ref = useMemo(
    () => mergeRefs([state.reference, propRef, childrenRef]),
    [state.reference, propRef, childrenRef]
  )

  const isValid = isValidElement(children)
  if (!isValid) {
    console.error('Tooltip: Invalid children passed to TooltipAnchor. The children must be a element.')
    return null
  }

  // `asChild` allows the user to pass any element as the anchor
  return cloneElement(children, state.getReferenceProps({ ref, ...props, ...children.props }))
})
